module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAUCAYAAAAKuPQLAAAAAXNSR0IArs4c6QAAAE9JREFUSA3t0LENACAMxEBgWHaCOTJfROnuawqnsvRNdLOqdnef8c/d9c8vfOJTWORSKvuwKoVFLqWyD6tSWORSKvuwKoVFLqWyD6tSWOR6UKYG12+ERvEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/No Active Patch.png
// module id = 312
// module chunks = 7